<template>
  <a-drawer
    title="协定方详情"
    placement="right"
    v-model:visible="visible"
    :after-visible-change="afterVisibleChange"
    :width="420"
    @close="onClose"
    :body-style="{ padding: '0px' }"
  >
    <a-spin :spinning="loading" v-if="visible">
      <div style="height: calc(100vh - 60px); overflow-y: scroll; padding: 20px">
        <div class="goodsInfo">
          <div class="image">
            <auth-img :src="info.imageInfo" style="width: 100%; height: 100%" />
          </div>
          <div class="info">
            <div class="top">
              <div class="title">
                <div class="elip--multiple" style="overflow: hidden; -webkit-line-clamp: 1">
                  {{ info.prescriptionName }}
                </div>
                <span v-if="info?.prescriptionNumber">({{ info.prescriptionNumber }})</span>
              </div>
              <auth-img class="img" :src="info.relationDoctor === 1 ? ksImage : zyImg" />
            </div>
            <div class="subClass">
              <div class="price">
                <span class="min" style="margin-right: 4px">¥</span>
                <span class="num">{{ getPrice(info?.chinesePrescriptionInfo?.price).int }}</span>
                <span class="min">
                  .{{ getPrice(info?.chinesePrescriptionInfo?.price).decimal }}
                </span>
                <span class="min">
                  /
                  <span style="margin-right: 5px">
                    {{ info?.usageDosage?.cycle }}{{ info?.usageDosage?.cycleUnit }}
                  </span>
                </span>
              </div>
              <a-popover trigger="click" destroyTooltipOnHide="true" placement="bottomRight">
                <template #content>
                  <a-spin :spinning="changeLoading">
                    <div class="priceList">
                      <template v-if="priceChangeList.length > 0">
                        <div v-for="(cItem, cIndex) in priceChangeList" class="item" :key="cIndex">
                          <div class="left">
                            ¥ {{ cItem?.changeAfterPrice || '0.00' }}/{{ cItem?.cycle }}
                            {{ cItem?.cycleUnit }}
                          </div>
                          <div class="right">{{ cItem?.createTime }}</div>
                        </div>
                      </template>
                      <a-empty v-else />
                    </div>
                  </a-spin>
                </template>
                <div class="priceDetail" @click="priceDetail">
                  零售价变更明细
                  <auth-img :src="rightArrow" class="rightArrow" />
                </div>
              </a-popover>
            </div>
          </div>
        </div>
        <div class="tip">
          <auth-img :src="rightIcon" class="rightIcon" />
          累计开具 {{ info.frequency }} 次
          <span v-if="info.effectiveRate">｜有效率 {{ info.effectiveRate }}</span>
        </div>
        <div class="tableDetail">
          <div class="manualContent">
            <div class="title">协定方说明书</div>
            <div
              v-for="(item, index) in detailList(info)"
              class="list"
              :key="index"
              :style="{ background: index % 2 === 0 ? '#F5F5F5' : '#FAFAFA' }"
            >
              <div class="left">
                {{ item.label }}
              </div>
              <div class="contentLine"></div>
              <div class="right">
                <textEllipsis
                  :key="index"
                  :unfoldBackgroundImage="
                    index % 2 === 0 ? unfoldBackgroundImage_1 : unfoldBackgroundImage_2
                  "
                  :text="item.value || '--'"
                  :rows="4"
                ></textEllipsis>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </a-drawer>
</template>
<script setup>
import { ref, defineExpose } from 'vue'
import { getAgreementDetail, getPriceChange } from '@/api/workPlace/agreement'
import zyImg from '@/assets/img/chat/agreement/zyImg.png'
import ksImage from '@/assets/img/chat/agreement/ksImage.png'
import rightArrow from '@/assets/img/chat/agreement/rightArrow.png'
import rightIcon from '@/assets/img/chat/agreement/rightIcon.png'
import { detailList } from './config'
import { getPrice } from './config'
import textEllipsis from './TextEllipsis.vue'

const unfoldBackgroundImage_1 = 'linear-gradient(90deg, #f5f5f500 0%, #F5F5F5 22%)'
const unfoldBackgroundImage_2 = 'linear-gradient(90deg, #fafafa00 0%, #FAFAFA 22%)'

const visible = ref(false)
const info = ref({})
const rowInfo = ref({})
const priceChangeList = ref([])
const changeLoading = ref(false)

const loading = ref(false)
const initData = rowData => {
  rowInfo.value = rowData
  visible.value = true
  getInfo()
}
const getChange = () => {
  const { prescriptionSn = '' } = rowInfo.value
  changeLoading.value = true
  const params = {
    page: 1,
    pageSize: 10000,
    businessId: prescriptionSn
  }
  getPriceChange(params)
    .then(res => {
      priceChangeList.value = res?.list
    })
    .finally(() => {
      changeLoading.value = false
    })
}
const priceDetail = () => {
  getChange()
}
const getInfo = () => {
  const { prescriptionSn = '' } = rowInfo.value
  try {
    const params = {
      prescriptionSn
    }
    getAgreementDetail(params)
      .then(res => {
        info.value = res
      })
      .catch(() => {
        onClose()
      })
      .finally(() => {
        loading.value = false
      })
  } catch (error) {
    loading.value = false
    onClose()
  }
}

const afterVisibleChange = () => {
  console.log('visible', visible.value)
}
const onClose = () => {
  visible.value = false
  console.log('Clicked cancel button')
}
defineExpose({ initData })
</script>

<style scoped lang="scss">
.priceList {
  width: 331px;
  max-height: calc(100vh - 250px);
  overflow: auto;
  .item {
    padding: 16px;
    background: #f6f7f8;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    border-radius: 8px;
    overflow: hidden;

    .left {
      font-weight: bold;
      font-size: 14px;
      color: #333333;
    }
    .right {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .item:last-child {
    margin-bottom: 0;
  }
}
.manualContent {
  background: #ffffff;
  border-radius: 8px;
  .list {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    position: relative;
    .left {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      padding: 12px;
      width: 80px;
      min-width: 80px;
    }

    .contentLine {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 1px;
      background: #fff;
      left: 80px;
    }

    .right {
      // border-left: 1px solid #FFFFFF;
      font-size: 14px;
      color: #1c1c1c;
      padding: 12px 16px;
      min-width: 90px;
    }
  }
}

.tableDetail {
  margin-top: 20px;
  .title {
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    margin-bottom: 12px;
  }
}
.tip {
  margin-top: 20px;
  padding: 10px 11px;
  font-weight: 400;
  font-size: 14px;
  color: #a66c5b;
  border-top: 1px solid #a77f7333;
  border-bottom: 1px solid #a77f7333;
  display: flex;
  align-items: center;
  .rightIcon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}
.goodsInfo {
  display: flex;
  width: 100%;
  align-items: center;
  .image {
    width: 74px;
    min-width: 74px;
    height: 74px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
    margin-right: 12px;
  }
  .info {
    width: 100%;
    .top {
      display: flex;
      align-items: center;
      .title {
        font-weight: bold;
        font-size: 18px;
        color: #1c1c1c;
        margin-right: 6px;
        display: flex;
      }
      .img {
        height: 22px;
      }
    }

    .subClass {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      align-items: baseline;
      .price {
        font-size: 18px;
        font-weight: 600;
        color: #f45959;
        .num {
          font-size: 18px;
        }
        .min {
          font-size: 14px;
        }
      }

      .priceDetail {
        font-weight: 400;
        font-size: 13px;
        color: #999999;
        display: flex;
        align-items: center;
        cursor: pointer;
        .rightArrow {
          width: 12px;
          height: 12px;
          margin-left: 4px;
        }
      }
    }
  }
}
</style>
